(() => {
  if (customElements.get('izy-cart-free-shipping')) return;
  customElements.define('izy-cart-free-shipping', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.formatter = new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency: this.dataset.currency });
      document.addEventListener('cart:change', event => {
        const items = event.detail?.cart?.items;
        if (!Array.isArray(items)) return;
        this.dataset.total = String(items.filter(item => item.requires_shipping).reduce((total, item) => total + item.original_line_price, 0));
        this.update();
      }, { signal: this.abort.signal });
      this.update();
    }
    update() {
      const remaining = Math.max(0, Number(this.dataset.threshold) - Number(this.dataset.total));
      if (!Number.isFinite(remaining)) return;
      this.querySelector('span').textContent = remaining === 0 ? this.dataset.reached : this.dataset.unreached.replace('[amount]', this.formatter.format(remaining / 100));
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
})();
